
import $ from 'jquery';
import Promise from 'Promise';

import translations from '../Languages';
import { factory as transitionFactory } from '../animation/AbstractTransition';

function render(tplName, data = {}) {
	data.lng = translations;
	return $(`<div>${window.nunjucks.render(tplName, data)}</div>`).get(0);
}

function Section() {
	this.render = (container) => {
		const onReady = (this.init && this.init()) || Promise.resolve();

		return onReady.then((res) => {
			const node = this.sectionNode = render(this.templateName, res || {});
			container.append(node);
			this.setupTransition(node);
			return node;
		});
	};

	//default quand fini animate out: remove node
	this.sleep = () => {
		$(this.sectionNode).remove();
	};

	this.onNext = (callback) => {
		this.next = callback;
	};

	this.onPrev = (callback) => {
		this.prev = callback;
	};

	return this;
}

export function factory(instance) {
	return Section.call(transitionFactory(instance || {}));
}


export function transitFromTo(container, fromSection, toSection) {
	const onOut = fromSection.animateOut();
	onOut.then(() => {
		toSection.render(container);
		return toSection.animateIn();
	});
}
